import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import InsertImageModal from "./InsertImageModal";
import { FiImage } from "react-icons/fi";

export default function AddTodoModal({ show, handleClose, addTodo }) {

const [title,setTitle]=useState("");
const [tag,setTag]=useState("");
const [priority,setPriority]=useState("");
const [assignee,setAssignee]=useState("");
const [status,setStatus]=useState("");
const [showImageModal,setShowImageModal]=useState(false);

const submitTodo=()=>{
addTodo({
title,
bg:"#ffffff",
date:"today"
});
handleClose();
};

return(
<>

<Modal show={show} onHide={handleClose} centered size="md" className="todo-modal">

<Modal.Header closeButton>
<Modal.Title>Add New Todo</Modal.Title>
</Modal.Header>

<Modal.Body>

<Form>

<Form.Group className="mb-3">
<Form.Label>Todo Title</Form.Label>
<Form.Control className="custom-input"/>
</Form.Group>

<Row>

<Col md={6}>
<Form.Group className="mb-3">
<Form.Label>Tag</Form.Label>

<Form.Select
className="custom-select"
value={tag}
onChange={(e)=>setTag(e.target.value)}
>
<option>Select</option>
<option>Internal</option>
<option>Projects</option>
<option>Meetings</option>
<option>Reminder</option>
</Form.Select>

</Form.Group>
</Col>

<Col md={6}>
<Form.Group className="mb-3">
<Form.Label>Priority</Form.Label>

<Form.Select
className="custom-select"
value={priority}
onChange={(e)=>setPriority(e.target.value)}
>
<option>Select</option>
<option>Medium</option>
<option>High</option>
<option>Low</option>
</Form.Select>

</Form.Group>
</Col>

</Row>

<Form.Group className="mb-3">

<Form.Label>Descriptions</Form.Label>

<div className="editor">

<div className="toolbar">

<select className="font-select">
<option>14</option>
<option>16</option>
</select>

<button><b>B</b></button>
<button><i>I</i></button>
<button><u>U</u></button>

<button className="image-btn"
onClick={(e)=>{
e.preventDefault();
setShowImageModal(true);
}}
>
<FiImage/>
</button>

</div>

<textarea className="editor-textarea"></textarea>

</div>

</Form.Group>

<Form.Group className="mb-3">
<Form.Label>Add Assignee</Form.Label>

<Form.Select
className="custom-select"
value={assignee}
onChange={(e)=>setAssignee(e.target.value)}
>
<option>Select</option>
<option>Sophie</option>
<option>Cameron</option>
<option>Doris</option>
<option>Rufana</option>
</Form.Select>

</Form.Group>

<Form.Group>
<Form.Label>Status</Form.Label>

<Form.Select
className="custom-select"
value={status}
onChange={(e)=>setStatus(e.target.value)}
>
<option>Select</option>
<option>Completed</option>
<option>Pending</option>
<option>Onhold</option>
<option>Inprogress</option>
</Form.Select>

</Form.Group>

</Form>

</Modal.Body>

<Modal.Footer>

<Button variant="light" onClick={handleClose}>
Cancel
</Button>

<Button className="add-btn" onClick={submitTodo}>
Add New Todo
</Button>

</Modal.Footer>

</Modal>

<InsertImageModal
show={showImageModal}
handleClose={()=>setShowImageModal(false)}
/>

<style>{`

.todo-modal .modal-content{
border-radius:8px;
}

.custom-input{
height:45px;
border:1px solid #ddd;
}

.custom-select{
height:45px;
border:1px solid #ddd;
}

.custom-select:focus{
border-color:#ff6a00;
box-shadow:none;
}

.editor{
border:1px solid #ddd;
border-radius:6px;
}

.toolbar{
display:flex;
gap:6px;
padding:8px;
border-bottom:1px solid #eee;
background:#fafafa;
}

.toolbar button{
border:1px solid #ddd;
background:#fff;
padding:4px 10px;
}

.image-btn{
display:flex;
align-items:center;
justify-content:center;
}

.font-select{
border:1px solid #ddd;
padding:4px;
}

.editor-textarea{
width:100%;
height:120px;
border:none;
padding:10px;
resize:none;
outline:none;
}

.add-btn{
background:#ff6a00;
border:none;
padding:8px 18px;
}

`}</style>

</>
);
}